module.exports = __webpack_public_path__ + "media/images/sort_asc_disabled-804b050e0fd378d630bd02c09a83a2fa.png";